var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransformation = function SvgTransformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 152 83"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.943,
    d: "M42.547 60.227c0-10.92-8.853-19.774-19.774-19.774C11.853 40.453 3 49.306 3 60.227 3 71.147 11.853 80 22.773 80c10.921 0 19.774-8.853 19.774-19.773Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.943,
    d: "M149.305 59.773c0-10.92-8.853-19.773-19.774-19.773-10.92 0-19.773 8.853-19.773 19.773 0 10.921 8.853 19.774 19.773 19.774 10.921 0 19.774-8.853 19.774-19.774Z",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3.296,
    d: "m72.168 70.752 9.887-9.887-9.887-9.887",
    opacity: 0.4
  })));
};
export default SvgTransformation;